import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CardLoader = () => (
  <div className="col-lg-4">
    <div className="card">
      <div className="item">
        <div className="img-sec">
          <Skeleton height={200} />
        </div>
        <div className="text-sec">
          <div className="cnt-sec">
            <h4>
              <Skeleton width={100} />
            </h4>
            <p className="mb-0">
              <Skeleton width={80} />
            </p>
            <p className="mb-0">
              <Skeleton width={120} />
            </p>
          </div>
          <div className="right-sec">
            <div className="rating-sec">
              <p>
                <Skeleton width={50} />
              </p>
            </div>
            <div className="price-sec">
              <p>
                <Skeleton width={50} />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default CardLoader;
